import {
  HTML_UNIQUE,
  HTML_MANIFEST,
  HTML_HASH,
  HTML_FUZZY,
  HTML_OTHER,
  HTML_UNMATCHED,
  HTML_IGNORE,
  HTML_VARIABLE,
  HTML_FUNCTION_UNIQUE,
  HTML_FUNCTION_KERNEL,
} from '../../constants/reports';

const tabDataFormatters = {
  [HTML_UNIQUE]: (data) => {
    return data.map(({
      component_name,
      crawled_file_name_count,
      line_number_count,
      scanned_file_name_count,
      version_count,
      unique_matches,
      component_count,
    }) => {
      return {
        component_name,
        identifier_count: component_count,
        crawled_file_name_count,
        line_number_count,
        scanned_file_name_count,
        version_count,
        unique_string_analysis: unique_matches
      };
    });
  },

  [HTML_MANIFEST]: (data) => {
    return data.map(({ component_name, component_count, manifest_matches }) => {
      const { label, manifest_array, ...rest } = manifest_matches;

      return {
        component_name,
        manifest_count: component_count,
        ...rest,
        manifest_file_analysis: manifest_array,
      };
    });
  },

  [HTML_HASH]: (data) => {
    return data.map(({
      component_name,
      crawled_file_name_count,
      scanned_file_name_count,
      sha256_count,
      version_count,
      hash_matches
    }) => {
      return {
        component_name,
        crawled_file_name_count,
        scanned_file_name_count,
        sha256_count,
        version_count,
        file_analysis: hash_matches
      };
    });
  },

  [HTML_FUZZY]: (data) => {
    return data.map(({
      component_name,
      crawled_file_name_count,
      scanned_file_name_count,
      version_count,
      fuzzy_matches
    }) => {
      return {
        component_name,
        crawled_file_name_count,
        scanned_file_name_count,
        version_count,
        file_analysis: fuzzy_matches
      };
    });
  },

  [HTML_OTHER]: (data) => {
    return data.map(({ component_name, other_matches }) => {
      const { label, string_array, ...rest } = other_matches;

      return {
        component_name,
        ...rest,
        identifier_count: string_array.length,
        identifier_analysis: string_array,
      };
    });
  },

  [HTML_UNMATCHED]: (data) => {
    const { string_array } = data;

    return {
      identifier_count: string_array.length,
      identifier_analysis: string_array,
    };
  },

  [HTML_IGNORE]: (data) => {
    const { string_array } = data;

    return {
      ignored_identifier_count: string_array.length,
      ignored_identifier_analysis: string_array,
    };
  },

  [HTML_VARIABLE]: (data) => {
    const { string_array } = data;

    return {
      unique_variable_count: string_array.length,
      unique_variable_analysis: string_array,
    };
  },

  [HTML_FUNCTION_UNIQUE]: (data) => {
    return data.map(({ component_name, unique_matches }) => {
      const { label, string_array, ...rest } = unique_matches;
      return {
        component_name,
        ...rest,
        unique_function_count: string_array.length,
        unique_function_analysis: string_array,
      };
    });
  },

  [HTML_FUNCTION_KERNEL]: (data) => {
    const { string_array } = data;

    return {
      kernel_function_count: string_array.length,
      kernel_function_analysis: string_array,
    };
  },
};

export function buildExportData({ tabDataMap, analysisInfo, exportFormat }) {
  const result = {
    analysis_info: analysisInfo,
    analysis_result: {},
  };

  const analysisResultTabs = [
    'unique_matches',
    'other_matches',
    'no_matches',
    'ignored',
    'variable_field_matches',
    'function_unique_matches',
    'function_kernel_matches',
    'manifest_matches',
    'hash_matches',
    'fuzzy_matches',
  ];

  Object.entries(tabDataMap).forEach(([tabId, rawData]) => {
    const formatter = tabDataFormatters[tabId];
    const formattedData = typeof formatter === 'function' ? formatter(rawData) : rawData;

    if (analysisResultTabs.includes(tabId)) {
      result.analysis_result[tabId] = formattedData;
    } else if (tabId !== 'analysis_info') {
      result[tabId] = formattedData;
    }
  });

  if (exportFormat === 'json') {
    return JSON.stringify(result, null, 2);
  }

  throw new Error(`Unsupported export format: ${exportFormat}`);
}

export function getTranslatedToConstantMap(t) {
  return {
    [t('modal.title.unique_matches')]: HTML_UNIQUE,
    [t('modal.title.manifest_matches')]: HTML_MANIFEST,
    [t('modal.title.hash_matches')]: HTML_HASH,
    [t('modal.title.fuzzy_matches')]: HTML_FUZZY,
    [t('modal.title.other_matches')]: HTML_OTHER,
    [t('modal.title.no_matches')]: HTML_UNMATCHED,
    [t('modal.title.ignored')]: HTML_IGNORE,
    [t('modal.title.variable_matches')]: HTML_VARIABLE,
    [t('modal.title.function_matches')]: HTML_FUNCTION_UNIQUE,
    [t('modal.title.function_kernel_matches')]: HTML_FUNCTION_KERNEL,
  };
}
